import React from 'react';
import PromptGenerator from '../generation/PromptGenerator';

export default function GeneratorTestPage() {
  const handleGenerate = (prompt) => {
    console.log('Generated Prompt:', prompt);
    alert(`Prompt wird generiert: ${prompt}`);
  };

  return <PromptGenerator onGenerate={handleGenerate} />;
}
